import { LayoutType } from 'src/app/core';
import { LayoutConfigBuilder } from 'src/app/layouts/default-layout/builders/layout-config.builder';
import { LayoutConfigPresets } from 'src/app/layouts/default-layout/models/layout-structures.models';
import { ReportBuilderReportType, ReportTemplateParamId } from './models/reports-builder.models';

export enum ReportsBuilderRoutesConfig {
	BASE_URL = 'reports-builder',
	NEW_REPORT = 'new',
	FILTERS_TAB = 'filters',
	LAYOUT_TAB = 'layout',
	TABLE_VIEW = 'report',
	SCHEDULE_TAB = 'schedule',
	REPORT_TEMPLATES = '',
	BASIC_SCHEDULES = 'basic-schedules',
	TRAINING_HISTORY = 'training-history'
}

export class ReportsBuilderRoutes {
	private static makeRoute(...routes: string[]): string {
		let route = '';
		routes.forEach(item => (route += `/${item}`));
		return route;
	}
	/**
	 *
	 * @param reportId optional param
	 * @returns returns `reportId` if provided or defaults ( to `new`)
	 */
	private static reportIdOrDefault(reportId?: ReportTemplateParamId): string {
		return !!reportId ? reportId.toString() : ReportsBuilderRoutesConfig.NEW_REPORT;
	}

	public static getEditReportRoute(reportType: ReportBuilderReportType, reportId?: ReportTemplateParamId): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			reportType,
			ReportsBuilderRoutes.reportIdOrDefault(reportId)
		);
	}

	public static getNewReportRoute(reportType: ReportBuilderReportType, reportId?: ReportTemplateParamId): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			reportType,
			ReportsBuilderRoutes.reportIdOrDefault(reportId)
		);
	}

	public static getHomepageRoute(): string {
		return ReportsBuilderRoutesConfig.BASE_URL;
	}

	public static getReportTemplatesRoute(): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			ReportsBuilderRoutesConfig.REPORT_TEMPLATES
		);
	}

	public static getBasicSchedulesRoute(): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			ReportsBuilderRoutesConfig.BASIC_SCHEDULES
		);
	}

	public static getTrainingHistoryRoute(): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			ReportsBuilderRoutesConfig.TRAINING_HISTORY
		);
	}

	public static getTableViewRoute(reportType: ReportBuilderReportType, reportId?: ReportTemplateParamId): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			reportType,
			ReportsBuilderRoutes.reportIdOrDefault(reportId),
			ReportsBuilderRoutesConfig.TABLE_VIEW
		);
	}

	public static getFiltersTabRoute(reportType: ReportBuilderReportType, reportId?: ReportTemplateParamId): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			reportType,
			ReportsBuilderRoutes.reportIdOrDefault(reportId),
			ReportsBuilderRoutesConfig.FILTERS_TAB
		);
	}

	public static getLayoutTabRoute(reportType: ReportBuilderReportType, reportId?: ReportTemplateParamId): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			reportType,
			ReportsBuilderRoutes.reportIdOrDefault(reportId),
			ReportsBuilderRoutesConfig.LAYOUT_TAB
		);
	}

	public static getScheduleTabRoute(reportType: ReportBuilderReportType, reportId?: ReportTemplateParamId): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			reportType,
			ReportsBuilderRoutes.reportIdOrDefault(reportId),
			ReportsBuilderRoutesConfig.SCHEDULE_TAB
		);
	}

	public static getScheduleReportRoute(reportType: ReportBuilderReportType, reportId?: ReportTemplateParamId): string {
		return ReportsBuilderRoutes.makeRoute(
			ReportsBuilderRoutesConfig.BASE_URL,
			reportType,
			ReportsBuilderRoutes.reportIdOrDefault(reportId),
			ReportsBuilderRoutesConfig.SCHEDULE_TAB
		);
	}
}

const createNewHomepageLayoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.default)
	.setBodyCssClasses(['bg--gray-lighter'])
	.build();

export const dataForHomepage = {
	layout: LayoutType.LARGE,
	layoutConfig: createNewHomepageLayoutConfig
};

const createNewReportLayoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.minimal)
	.setBodyCssClasses(['bg--white'])
	.setContentCssClasses(['wrap--no-subheader', 'wrap--action-footer'])
	.setHeaderCssClasses(['header--no-scroll'])
	.setFooterCssClasses(['footer-white'])
	.setAdminWrapCssClasses(['admin-wrap--no-sidenav'])
	.build();

export const dataForCreateNewReport = {
	layout: LayoutType.DEFAULT,
	layoutConfig: createNewReportLayoutConfig
};

const listViewLayoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.minimal)
	.setBodyCssClasses(['bg--white'])
	.setContentCssClasses(['wrap--no-subheader', 'wrap--no-scroll'])
	.setHeaderCssClasses(['header--no-scroll'])
	.setAdminWrapCssClasses(['admin-wrap--no-sidenav'])
	.build();

export const dataForListView = {
	layout: LayoutType.FLUID,
	layoutConfig: listViewLayoutConfig
};
